export default {
  "supplierSap": {
    "adminOnly": "관리자만 공급업체 원본 확인과 동기화를 실행할 수 있습니다",
    "systemInvalid": "SAP 공급업체 원본 시스템 설정이 올바르지 않습니다. 관리자에게 문의하세요",
    "schemaMissing": "공급업체 동기화 구조가 준비되지 않았습니다. 검토된 마이그레이션 후 다시 시도하세요",
    "sourceLimit": "공급업체 원본이 한 번의 확인 범위를 초과했습니다. 관리자에게 문의하세요",
    "previewChanged": "공급업체 원본 또는 목록이 변경되었습니다. 다시 확인한 후 동기화하세요",
    "readonly": "공급업체 기본 정보는 SAP에서 관리합니다. SAP 수정 후 SP0230으로 동기화하세요"
  }
};
